<template>
  <div>
    <h2 class="uk-text-center AppTitle Title">{{'properties' | translate}}</h2>
    <div class="uk-child-width-1-3@m" uk-grid>
      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <div class="uk-cover-container" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_1.jpg`" alt="" uk-cover>
            </div>
          </div>
          <div class="uk-card-body">
            <router-link class="uk-h4 uk-margin-remove" to="/casamia-nilaveli">CASAMIA Nilaveli</router-link>
          </div>
        </div>
      </div>
      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <div class="uk-cover-container" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_3.jpg`" alt="" uk-cover>
            </div>
          </div>
          <div class="uk-card-body">
            <router-link class="uk-h4 uk-margin-remove" to="/casamia-colombo">CASAMIA Colombo</router-link>
          </div>
        </div>
      </div>
      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <div class="uk-cover-container" tabindex="0">
              <canvas height="250"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/img_5.jpg`" alt="" uk-cover>
            </div>
          </div>
          <div class="uk-card-body">
            <router-link class="uk-h4 uk-margin-remove" to="/turtle-nest">Turtle Nest Rekawa</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurCollectionComponent'
}
</script>

<style scoped>

</style>
